"use client";
import { jsx as n } from "react/jsx-runtime";
import { Portal as l, Shadow as d, RootProvider as h, Modal as e } from "@inkeep/cxkit-styled";
function m(o) {
  const { componentType: r, children: t, modalSettings: i, ...c } = o;
  return /* @__PURE__ */ n(l, { children: /* @__PURE__ */ n(d, { children: /* @__PURE__ */ n(
    h,
    {
      config: {
        ...c
      },
      componentType: r,
      children: /* @__PURE__ */ n(e.Root, { config: i, children: t })
    }
  ) }) });
}
function p(o) {
  return /* @__PURE__ */ n(e.Overlay, { children: /* @__PURE__ */ n(e.Content, { children: o.children }) });
}
export {
  m as InkeepModal,
  p as ModalContent
};
